import { action } from 'satcheljs';
import { ActionSource } from 'owa-analytics-actions';

/**
 * This action is used to delete itemparts in an expanded conversation.
 * For first level expansion, the item parts are threads and for second level expansion, they are nodes in the conversation.
 */
export default action(
    'DELETE_ITEMS_BASED_ON_NODE_OR_THREAD_IDS',
    (nodeIds: string[], tableViewId: string, actionSource: ActionSource) => ({
        nodeIds,
        tableViewId,
        actionSource,
    })
);
